import React, { Component } from 'react';

import TopicCard from '../TopicCard/TopicCard';
import CompleteMessage from '../CompleteMessage/CompleteMessage';

import { withContext } from '../../App';

import './styles.scss';

class OtherTopics extends Component {
  render() {
    const { context: { topics, scenariosComplete } } = this.props;

    return (
      <div className="other-topics row">
        {
          scenariosComplete.length < 6 ? (
            <React.Fragment>
              <div className="col-xs-12">
                <div className="other-topics-header mt-2 mb-2">How else would you spend the budget?</div>
              </div>
              {
                Object.keys(topics).map((topic, index) => {
                  return (
                    <div key={index} className="col-xs-12 col-md-6 col-lg-6 mb-2">
                      <TopicCard topic={topics[topic]} isMini />
                    </div>
                  )
                })
              }
            </React.Fragment>
          ) : (
              <CompleteMessage />
            )
        }
      </div>
    );
  }
}

export default withContext(OtherTopics);
